export function formatCurrency(v, opts = {}) {
  if (v === null || v === undefined || v === "" || isNaN(Number(v))) return "-";
  const n = Number(v);
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(abs >= 10_000_000 ? 0 : 1)}M`;
  if (abs >= 1_000) return `${sign}$${(abs / 1_000).toFixed(abs >= 100_000 ? 0 : 1)}k`;
  return `${sign}$${abs.toLocaleString()}`;
}

export function formatNumber(v) {
  if (v === null || v === undefined || v === "" || isNaN(Number(v))) return "-";
  return Number(v).toLocaleString();
}

export function formatPercent(v) {
  if (v === null || v === undefined || v === "" || isNaN(Number(v))) return "-";
  return `${Number(v).toFixed(1).replace(/\.0$/, "")}%`;
}

export function formatMonths(v) {
  if (v === null || v === undefined || v === "" || isNaN(Number(v))) return "-";
  return `${Number(v).toFixed(1).replace(/\.0$/, "")} mo`;
}

export function formatMetric(type, v) {
  switch (type) {
    case "currency": return formatCurrency(v);
    case "percent": return formatPercent(v);
    case "months": return formatMonths(v);
    default: return formatNumber(v);
  }
}

export function formatPeriodLabel(period) {
  if (!period) return "";
  const m = /^(\d{4})-(\d{2})$/.exec(period);
  if (!m) return period;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, 1);
  return d.toLocaleDateString(undefined, { month: "short", year: "numeric" });
}

export function formatDate(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); }
  catch { return iso; }
}

export function formatDateTime(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
}
